export default "__VITE_ASSET__D7N_DRVT__"